import { BlogsPage } from '../../types';
import BlogList from '../BlogList';
import ListingTemplate from './ListingTemplate';

const BlogListingPage = ({ data, ...post }: BlogsPage) => (
  <ListingTemplate {...post}>
    {data?.items && <BlogList blog={{ tags: data.tags, items: data.items }} />}
  </ListingTemplate>
);

export default BlogListingPage;
